
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Product } from '@/types/portfolio';

export const useProduct = (productId: string) => {
  const {
    data: product,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['product', productId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('id', productId)
        .single();
      
      if (error) throw error;
      return data as Product;
    },
    enabled: !!productId
  });

  return {
    product,
    isLoading,
    error,
    refetch
  };
};
